import Vue from 'vue'
import App from './app'
import router from './router'
import store from './state/store'
import moment from 'moment'
import chartjs from 'chart.js'
import helper from './plugins/vue-gridform/shared/helper'
import './plugins/vue-gridform/shared/inline-worker'

const isDev = process.env.NODE_ENV === 'development' || process.env.VUE_APP_DEV === 'true'

chartjs.defaults.global.defaultFontFamily = 'DIN, Roboto, Helvetica, Arial'

// Vuetify
import vuetify from './plugins/vuetify' // path to vuetify export
// expose LangTranslator to gridforms helper
helper.i18n = vuetify.framework.lang.t.bind(vuetify.framework.lang)

// Plugins
import VueGridform from './plugins/vue-gridform'
import { VueAutofocus } from '@aburai/vue-autofocus'
import VueToast from './plugins/vue-toast'
import VueHighlight from '@aburai/vue-highlight'
import VueDomToImage from './plugins/vue-dti'
import VueTour from './plugins/vue-tour'
import VueTreemap from './plugins/vue-treemap'
import VueVisibility from './plugins/vue-visibility'
import VueJson from './plugins/vue-json'
import VueXlsx from './plugins/vue-xlsx'
import VueNumeral from './plugins/vue-numeral'

const lang = 'de'
moment.locale(lang)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = false
Vue.config.devtools = false

Vue.prototype.$toast = VueToast
window.$toast = VueToast
VueToast.defaults({ offsetY: 48 })

Vue.use(VueGridform, { store })
Vue.use(VueAutofocus)
Vue.use(VueHighlight)
Vue.use(VueDomToImage)
Vue.use(VueTour)
Vue.use(VueTreemap)
Vue.use(VueVisibility)
Vue.use(VueXlsx)
Vue.use(VueNumeral, {lang})

Vue.prototype.$json = VueJson
if (isDev) window.$json = VueJson

// If running inside Cypress...
if (window.Cypress) {
    // Ensure tests fail when Vue emits an error.
    Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}
else {
    Vue.config.errorHandler = function(err, vm, info) {
        const text = err ? err.toString() : 'Es ist ein unerwarteter Fehler aufgetreten!'
        if (isDev) {
            console.groupCollapsed('global error handling')
            console.error('err', err)
            console.error('vm', vm)
            console.error('info', info)
            console.groupEnd()
        }
        VueToast.open({
            title: 'Achtung',
            text,
            type: 'error',
            timeout: -1 // do not hide
        })
    }
}

const app = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app')

// If running inside Cypress...
if (window.Cypress) {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
}
